"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.c = void 0;
const react_1 = __importStar(require("react"));
const base_1 = __importDefault(require("../../../client/buttons/base"));
const helpers_1 = require("../../../client/draftster/helpers");
const error_handler_1 = __importDefault(require("../../../services/error_handler"));
const graphql_1 = require("../../../requests/graphql");
const types_1 = require("../../../utility/types");
const time_1 = require("../../../utility/time");
const validators_1 = require("../../../services/validation/validators");
const dispatchers_1 = require("../../../utility/dispatchers");
const CurrentView_1 = __importDefault(require("./CurrentView"));
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
exports.c = {
    container: `${util_css_1.default.border} ${util_css_1.default.borderRadius} ${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter15}`,
    subHeader: `${util_css_1.default.bgFog} ${util_css_1.default.borderRadiusTopLeftTopRight} ${layout_css_1.default.padding15} ${layout_css_1.default.paddingLeft30} ${typography_css_1.default.h3Responsive}`,
    form: `${layout_css_1.default.padding30} ${layout_css_1.default.paddingTop0}`,
};
const Form = ({ activeTab, giveaway, setGiveaway, pendingChanges, }) => {
    const [errors, setErrors] = (0, react_1.useState)({});
    const [form, setForm] = (0, react_1.useState)({ id: giveaway.id });
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const overviewRef = (0, react_1.useRef)(null);
    const rulesRef = (0, react_1.useRef)(null);
    const formFields = (0, react_1.useMemo)(() => ({
        description: [
            {
                name: 'content',
                value: form.content,
                validFn: () => null,
            },
        ],
        settings: [
            {
                name: 'end_date',
                value: pendingChanges.has('end_date')
                    ? form.end_date
                    : giveaway.end_date,
                validFn: (val) => (0, validators_1.isRequired)(val) || (pendingChanges.has('end_date') && (0, time_1.isDatetimeLocalValueInPast)(val))
                    ? 'Please select a date in the future'
                    : null,
            },
            {
                name: 'slug',
                value: pendingChanges.has('slug') ? form.slug : giveaway?.slug,
                validFn: (val) => (0, validators_1.isRequired)(val) || (0, validators_1.isValidSlug)(val),
            },
            {
                name: 'sponsor_ids',
                value: pendingChanges.has('sponsor_ids')
                    ? form.sponsor_ids
                    : giveaway?.sponsor_ids,
                validFn: () => null,
            },
            {
                name: 'start_date',
                value: pendingChanges.has('start_date')
                    ? form.start_date
                    : giveaway.start_date,
                validFn: (val) => (0, validators_1.isRequired)(val) || (pendingChanges.has('start_date') && (0, time_1.isDatetimeLocalValueInPast)(val))
                    ? 'Please select a date in the future'
                    : null,
            },
        ],
        overview: [
            {
                name: 'alternate_cover_image',
                value: {
                    id: pendingChanges.has('alternate_cover_image')
                        ? form.alternate_cover_image?.id
                        : giveaway.alternate_cover_image?.id,
                    url: pendingChanges.has('alternate_cover_image')
                        ? form.alternate_cover_image?.url
                        : giveaway.alternate_cover_image?.url,
                },
                validFn: (val) => (0, validators_1.isRequired)(val.id) || (0, validators_1.imageV)(val),
            },
            {
                name: 'cover_image',
                value: {
                    id: pendingChanges.has('cover_image')
                        ? form.cover_image?.id
                        : giveaway.cover_image?.id,
                    url: pendingChanges.has('cover_image')
                        ? form.cover_image?.url
                        : giveaway.cover_image?.url,
                },
                validFn: (val) => (0, validators_1.isRequired)(val.id) || (0, validators_1.imageV)(val),
            },
            {
                name: 'teaser',
                value: form.teaser,
                validFn: (value) => (!value ? null : (0, validators_1.maxLength)(180, value)),
            },
            {
                name: 'title',
                value: pendingChanges.has('title') ? form.title : giveaway.title,
                validFn: (val) => (0, validators_1.isRequired)(val),
            },
        ],
        prizes: [
            {
                name: 'name',
                value: form?.prizes,
                validFn: (val) => (0, validators_1.isRequired)(val.name),
            },
            {
                name: 'cash_value',
                value: form?.prizes,
                validFn: (val) => (0, validators_1.isRequired)(val.cash_value),
            },
            {
                name: 'description',
                value: form?.prizes,
                validFn: (val) => !val.description ? null : (0, validators_1.maxLength)(180, val.description),
            },
            {
                name: 'link',
                value: form?.prizes,
                validFn: (val) => (0, validators_1.isUrlIfDefined)(val.link),
            },
            {
                name: 'quantity',
                value: form?.prizes,
                validFn: (val) => (0, validators_1.isRequired)(val.quantity),
            },
            {
                name: 'prize_type',
                value: form?.prizes,
                validFn: (val) => (0, validators_1.isRequired)(val.prize_type),
            },
        ],
        rules: [
            {
                name: 'rules',
                value: form.rules,
                validFn: () => null,
            },
        ],
        surveys: [
            {
                name: 'version',
                value: form?.surveys,
                validFn: (val) => (0, validators_1.isRequired)(val.version),
            },
            {
                name: 'survey_slug',
                value: form?.surveys,
                validFn: (val) => (0, validators_1.isRequired)(val.survey_slug) || (0, validators_1.isValidSlug)(val.survey_slug),
            },
        ],
    }), [form, giveaway, pendingChanges]);
    const validateFields = (0, react_1.useCallback)((section) => {
        const formErrors = formFields[section]?.reduce((acc, { name, value, validFn }) => {
            // prizes and surveys is an array of values.
            if (Array.isArray(value)) {
                value.forEach((val) => {
                    const res = validFn(val);
                    const fieldName = `${section}-${val.id}-${name}`;
                    if (res && pendingChanges.has(fieldName))
                        acc[fieldName] = res;
                    return acc;
                });
                return acc;
            }
            const res = validFn(value);
            if (res)
                acc[name] = res;
            return acc;
        }, {});
        // todo scroll to errors
        setErrors(formErrors);
        return !(0, types_1.isBlank)(formErrors);
    }, [formFields, pendingChanges]);
    const formatForm = (0, react_1.useCallback)(async () => {
        const field = pendingChanges.has('content')
            ? 'content'
            : pendingChanges.has('rules')
                ? 'rules'
                : null;
        const content = field
            ? JSON.stringify(await (0, helpers_1.buildContentObjectForPropagation)(field === 'content' ? overviewRef : rulesRef))
            : null;
        const formattedForm = { ...form };
        // if either cover image is updated, send both ids!
        if (pendingChanges.has('alternate_cover_image')
            || pendingChanges.has('cover_image')) {
            const altImage = form.alternate_cover_image?.id ? form.alternate_cover_image : giveaway.alternate_cover_image;
            const coverImage = form.cover_image?.id ? form.cover_image : giveaway.cover_image;
            formattedForm.alternate_cover_image = altImage;
            formattedForm.cover_image = coverImage;
        }
        field ? (formattedForm[field] = content) : formattedForm;
        return formattedForm;
    }, [form, giveaway.alternate_cover_image, giveaway.cover_image, pendingChanges]);
    const handleSubmit = (0, react_1.useCallback)(async (e) => {
        e.preventDefault();
        const hasErrors = validateFields(activeTab);
        if (hasErrors)
            return;
        setIsSubmitting(true);
        const f = await formatForm();
        (0, graphql_1.graphMutate)({ t: 'update_giveaway' }, f)
            .then(({ giveaway }) => {
            setGiveaway(giveaway);
            setForm({ id: giveaway.id });
            (0, dispatchers_1.summonGlobalMessenger)({ msg: 'Saved changes.', type: 'success' });
            // todo scroll back to top
        })
            .catch((err) => {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: JSON.parse(err.response.text).errors[0],
                type: 'error',
            });
            (0, error_handler_1.default)('Giveaway Dashboard handleSubmit Error: ', err);
        })
            .finally(() => {
            pendingChanges.clear();
            setIsSubmitting(false);
        });
    }, [activeTab, formatForm, pendingChanges, setGiveaway, validateFields]);
    const handleClearForm = () => {
        setForm({ id: giveaway.id });
        setErrors({});
        pendingChanges.clear();
    };
    const hideActionBar = activeTab === 'mailIn' || activeTab === 'winners';
    return (react_1.default.createElement("form", { onSubmit: handleSubmit },
        react_1.default.createElement(CurrentView_1.default, { activeTab: activeTab, errors: errors, form: form, giveaway: giveaway, isSubmitting: isSubmitting, overviewRef: overviewRef, pendingChanges: pendingChanges, rulesRef: rulesRef, setErrors: setErrors, setForm: setForm, setIsSubmitting: setIsSubmitting }),
        !hideActionBar
            && (react_1.default.createElement("div", { className: `${layout_css_1.default.flexJustifyEnd} ${layout_css_1.default.gutter5} ${layout_css_1.default.paddingTop30}` },
                react_1.default.createElement(base_1.default, { colorStyle: "cancel", disabled: isSubmitting, onClick: handleClearForm, size: "md", type: "button" }, "Cancel"),
                react_1.default.createElement(base_1.default, { disabled: isSubmitting, onClick: handleSubmit, size: "md", type: "submit" }, "Save")))));
};
exports.default = Form;
